import React from 'react';

export const Header = (props) => {
  return (
    <header id='header'>
      <div className='scroll-text'>
        <p>
          Water Purifier Repair &amp; Home Visit Charge - ₹199/- | Installation Charges - ₹499/- in Patna. Call - 91622 81169
        </p>
      </div>
    </header>
  )
}
